export default "/assets/images/hhr-access-screenshot.827c0f8ab895625b.webp";